import React, { useEffect, useState } from 'react'
import CustomBreadcrumb from '../common/CustomBreadcrumb';
import Alert from '../common/Alert';
import { Button, Col, Container, Row } from 'react-bootstrap';
import ResponsiveTable from '../Grid/ResponsiveTable';
import InputBox from '../common/InputBox';
import { convertDateForPicker, convertDateTimetoDateFormat, formatDateTime } from "../../helpers/date-formatter";
import { getBranchUserValidationLogs } from '../../services/reportlog-service';
import DatePicker from '../common/DatePicker';
import Loader from '../common/loader';
import { validateAlphaNumeric } from '../../helpers/validations';

export default function BranchUserValidationLog() {

  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(false);
  const [data, setData] = useState([]);

  const oneYearAgo = new Date();
  oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

  const [reportLogObj, setReportLogObj] = useState({
    productCode: "",
    serialNumber: "",
    validationDate: { fromDate: convertDateTimetoDateFormat(oneYearAgo), toDate: convertDateTimetoDateFormat(new Date()) },
    financeCode: "",
    vendorCode: "",
  });

  const handleReset = () => {
    setReportLogObj({
      productCode: "",
      serialNumber: "",
      validationDate: { fromDate: convertDateTimetoDateFormat(oneYearAgo), toDate: convertDateTimetoDateFormat(new Date()) },
      financeCode: "",
      vendorCode: "",
    });
    setData([]);
  }

  const handleChange = (e, picker) => {
    const { name, value } = e.target;
    setReportLogObj((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    if (picker) {
      setReportLogObj((prevState => ({
        ...prevState,
        validationDate: {
          fromDate: picker.startDate.format('YYYY-MM-DD'),
          toDate: picker.endDate.format('YYYY-MM-DD')
        }
      })));
    }
  }

  const [headers] = useState([
    { displayName: "Product Code", columnName: "productCode", dataType: "text", width: 170, maxLength: 50, displayIndication: true, required: true },
    { displayName: "Serial Number", columnName: "serialNumber", dataType: "text", width: 170, maxLength: 50, displayIndication: true, required: true },
    { displayName: "Processing Message", columnName: "processingMessage", dataType: "text", width: 240, maxLength: 50, displayIndication: true, required: true },
    { displayName: "Processed On", columnName: "createdOn", dataType: "date", width: 180, displayIndication: true, formatter: formatDateTime },
    { displayName: "Vendor Code", columnName: "vendorCode", dataType: "text", width: 160, maxLength: 50, displayIndication: true, required: true },
    { displayName: "Finance Code", columnName: "financeCode", dataType: "text", width: 160, maxLength: 50, displayIndication: true, required: true },
  ]);

  useEffect(() => {
    let timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, [reload]);

  const getLogs = async () => {
    if (!reportLogObj.productCode || reportLogObj.productCode.trim() === '') {
      Alert("error", "Product Code is mandatory");
      return;
    }
    if (!reportLogObj.serialNumber || reportLogObj.serialNumber.trim() === '') {
      Alert("error", "Serial Number is mandatory");
      return;
    }

    setLoading(true);
    try {
      let result = await getBranchUserValidationLogs(reportLogObj);
      if (result) {
        setData(result);
        if (result.length === 0) {
          Alert("info", "No data found");
        }
      }
    } catch (error) {
      Alert("error", error.response?.data?.message || error.message || "Error fetching data");
    }
    setLoading(false);
  }

  const commonProps = { onChange: handleChange }

  const initialSettingsProps = {
    maxSpan: { 'day': 365 },
    fromDate: convertDateForPicker(oneYearAgo),
    toDate: convertDateForPicker(new Date()),
    maxDate: convertDateForPicker(new Date()),
    minDate: convertDateForPicker(oneYearAgo)
  };

  return (
    <>
      {loading && <Loader />}
      <CustomBreadcrumb parentMenu={"Report"} menu={"Branch Validation Log Report"}> </CustomBreadcrumb>
      <Container bsPrefix="main-body drop-down">
        <div className="page-title">Branch User Validation Log Report</div>
        <Row>
          <Col lg={3} md={12} className="txt-input">
            <InputBox type="text" label="Product Code *" name="productCode" value={reportLogObj.productCode} customValidation={validateAlphaNumeric} required {...commonProps} />
          </Col>
          <Col lg={3} md={12} className="txt-input">
            <InputBox type="text" label="Serial Number *" name="serialNumber" value={reportLogObj.serialNumber} customValidation={validateAlphaNumeric} required {...commonProps} />
          </Col>
          <Col lg={3} md={12} className="txt-input">
            <DatePicker label="Validation Date (Past 1 Year)" name="validationDate" value={reportLogObj.validationDate} {...commonProps} initialSettingsProps={initialSettingsProps} required="true" />
          </Col>
        </Row>
        <Row className='mb-2'>
          <Col lg={3} md={12} className="txt-input">
            <InputBox type="text" label="Finance Code" name="financeCode" value={reportLogObj.financeCode} customValidation={validateAlphaNumeric} {...commonProps} />
          </Col>
          <Col lg={3} md={12} className="txt-input">
            <InputBox type="text" label="Vendor Code" name="vendorCode" value={reportLogObj.vendorCode} customValidation={validateAlphaNumeric} {...commonProps} />
          </Col>
          <Col className="display-action-btn">
            <Button onClick={handleReset} className="btn btn-outline-primary reset-button" variant="outline-primary">Reset</Button>
            <Button onClick={getLogs} className="btn btn-primary btn-color btn-go">Go</Button>
          </Col>
        </Row>
        <ResponsiveTable
          headers={headers}
          data={data}
          icons={[]}
          DisplayExcelDownload={true}
          dataType={"Branch User Validation Logs"}
          sessionName={"Branch Validation Log Report"}
          setReload={setReload}
          reload={reload}
          pageSize={5}
        />
      </Container>
    </>
  )
}
